import * as vp from 'vopay';
import { useContext, useEffect, FunctionComponent, useState } from 'react';
import { useParams } from 'react-router-dom';
import AccountContext from '../Accounts/AccountContext';
import InteracMoneyRequestTransactionInfo from './InteracMoneyRequestTransactionInfo';
import useFetchInteracMoneyRequestTransaction from '../../hooks/useApi/useFetchInteracMoneyRequestTransaction';

type FC = FunctionComponent<vp.TransactionIdAndType>;

const InteracMoneyRequestTransactionContainer: FC = (props: vp.TransactionIdAndType) => {
  const { accountId } = useParams<{ accountId: string }>();
  const { TransactionID, Type } = props;
  const { details } = useContext(AccountContext);
  let token = '';
  if (details[accountId]) {
    token = details[accountId].token;
  }
  const [InteracMoneyRequest, getInteracMoneyRequestTransaction] = useFetchInteracMoneyRequestTransaction({
    bearer: token,
  });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.InteracTransactionResponse>();

  useEffect(() => {
    if (Type === vp.TransactionType.INTERACT_MONEY_REQUEST) {
      getInteracMoneyRequestTransaction(TransactionID);
    }
  }, [currentTransactionId]);

  useEffect(() => {
    if (InteracMoneyRequest) {
      setTransaction(InteracMoneyRequest);
    }
  }, [InteracMoneyRequest]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <InteracMoneyRequestTransactionInfo transaction={transaction} />}</div>;
};

export default InteracMoneyRequestTransactionContainer;
